import { render, staticRenderFns } from "./FilterContactContentField.vue?vue&type=template&id=6cfd956c&scoped=true"
import script from "./FilterContactContentField.vue?vue&type=script&lang=ts"
export * from "./FilterContactContentField.vue?vue&type=script&lang=ts"
import style0 from "./FilterContactContentField.vue?vue&type=style&index=0&id=6cfd956c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd956c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/filter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2Fform%2FFilterContactContentField.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports